// ===== RB Sibling Swap analytics (Roobear) =====
// rb-sibling-swap.js swaps colour siblings in place, so nothing that fires on page load
// fires again: Shopify's product_viewed / page_viewed (which drive the Google & YouTube
// and Meta app pixels), Klaviyo's Viewed Product, and ShopifyAnalytics.meta. Shopify
// does not let a theme re-emit standard events, so on rb:sibling:swap this:
//   1. refreshes ShopifyAnalytics.meta from the new page,
//   2. re-runs Klaviyo's Viewed Product snippet from the new page's <head>,
//   3. sends GA4 / Google Ads view_item in the same shape the Google app sends it,
//   4. publishes a custom web pixel event (rb_sibling_view) for custom pixels.
// Meta ViewContent is NOT re-sent here: confirm the app's content_ids format first.
(function () {
  if (window.RB_SIBLING_ANALYTICS) return;
  window.RB_SIBLING_ANALYTICS = true;

  function headScript(doc, needle) {
    var list = doc.head ? doc.head.querySelectorAll('script:not([src])') : [];
    for (var i = 0; i < list.length; i++) {
      if ((list[i].textContent || '').indexOf(needle) > -1) return list[i].textContent;
    }
    return null;
  }

  function syncMeta(doc) {
    var code = headScript(doc, 'var meta = {');
    var m = code && code.match(/var meta = (\{[\s\S]*?\});\s*\n/);
    if (!m) return null;
    var meta = JSON.parse(m[1]);
    window.ShopifyAnalytics = window.ShopifyAnalytics || {};
    var cur = window.ShopifyAnalytics.meta = window.ShopifyAnalytics.meta || {};
    for (var k in meta) if (meta.hasOwnProperty(k)) cur[k] = meta[k];
    return meta;
  }

  function klaviyoViewed(doc) {
    var code = headScript(doc, "'Viewed Product'");
    if (!code) return;
    window.item = null; // the snippet only runs when the global `item` is unset
    var s = document.createElement('script');
    s.text = code;
    document.head.appendChild(s);
    document.head.removeChild(s);
  }

  function selectedVariant(product) {
    var input = document.querySelector('#MainContent [data-product-form] [name="id"]');
    var id = input && String(input.value);
    var vs = (product && product.variants) || [];
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) return vs[i];
    return vs[0] || null;
  }

  function productName() {
    var ld = document.querySelectorAll('#MainContent script[type="application/ld+json"]');
    for (var i = 0; i < ld.length; i++) {
      try { var j = JSON.parse(ld[i].textContent); if (j && j['@type'] === 'Product' && j.name) return j.name; } catch (e) {}
    }
    return document.title;
  }

  // Reuse the destinations the Google app configured for its own view_item, so this
  // stays in step with the app and sends nothing if the app (or consent) sent nothing.
  function googleSendTo() {
    var dl = window.dataLayer || [];
    for (var i = dl.length - 1; i >= 0; i--) {
      var e = dl[i];
      if (e && e[0] === 'event' && e[1] === 'view_item' && e[2] && e[2].send_to) return e[2].send_to;
    }
    return null;
  }

  function googleViewItem(product, v, name) {
    var sendTo = googleSendTo();
    if (!sendTo || typeof window.gtag !== 'function' || !v) return;
    var country = (window.Shopify && Shopify.country) || 'CA';
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    var id = 'shopify_' + country + '_' + product.id + '_' + v.id;
    var price = v.price / 100;
    window.gtag('event', 'view_item', {
      send_to: sendTo,
      ecomm_prodid: [id],
      ecomm_totalvalue: price,
      ecomm_pagetype: 'product',
      value: price,
      currency: currency,
      items: [{
        id: id,
        name: name,
        brand: product.vendor,
        category: product.type,
        price: price,
        variant: v.public_title || null,
        quantity: 1,
        sku: v.sku,
        variant_id: String(v.id)
      }]
    });
  }

  document.addEventListener('rb:sibling:swap', function (e) {
    var doc = e.detail && e.detail.doc;
    if (!doc) return;
    var meta = null;
    try { meta = syncMeta(doc); } catch (err) {}
    try { klaviyoViewed(doc); } catch (err) {}
    var product = meta && meta.product;
    if (!product) return;
    var v = selectedVariant(product);
    var name = productName();
    try { googleViewItem(product, v, name); } catch (err) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('rb_sibling_view', {
          productId: product.id, variantId: v && v.id, handle: e.detail.handle, url: e.detail.url
        });
      }
    } catch (err) {}
  });
})();
